import React from 'react';
import { HomeIcon, RocketLaunchIcon } from '@heroicons/react/24/outline';
import {
  Breadcrumbs,
  isPermitted,
  Panel,
  useListCloudIntegrations,
} from '@plerionhq/design-system';
import { IntegrationCard } from '@plerionhq/design-system/experimental';
import { AddCloudIntegration } from '../component-library/AddCloudIntegration';
import { useUserProfile } from '../api/profile';

import { useTranslation } from 'react-i18next';

export const EnvironmentsPage = () => {
  const { t } = useTranslation('containerInterface');
  const { data: cloudIntegrations, isLoading } = useListCloudIntegrations();
  const { data: userData } = useUserProfile();
  const permissions = userData?.permissions || [];
  const isReadonly = !isPermitted(permissions, [
    'organization:Administration',
    'tenant:Administration',
  ]);

  return (
    <div className="my-2 flex max-w-[1900px] flex-col gap-y-4 px-2 pb-16 sm:my-4 xl:px-4 2xl:mx-auto">
      <div className="flex flex-row items-center gap-x-3">
        <Breadcrumbs
          items={[
            {
              name: t('common:home'),
              icon: HomeIcon as BreadcrumbIcon,
              to: `/`,
            },
            { name: t('common:settings'), to: '/settings' },
            { name: t('environments') },
          ]}
        />
      </div>
      <Panel>
        <div className="flex flex-col gap-4 p-5 sm:flex-row sm:items-center">
          <div className="bg-br-primary/10 text-br-primary flex-shrink-0 self-center rounded-lg p-4">
            <RocketLaunchIcon className="h-16 w-16 sm:h-8 sm:w-8" />
          </div>
          <div>
            <h2 className="text-2xl leading-tight font-medium text-gray-700 dark:text-gray-300">
              {t('environments')}
            </h2>
            <p className="text-darkest-gray mt-2 text-sm font-normal">
              {t('classifyYourCloudAccountsByEnvironmentAnd')}
            </p>
          </div>
        </div>
      </Panel>
      <Panel>
        <Panel.Body className="flex h-full w-full flex-col gap-3">
          {!isLoading && cloudIntegrations && cloudIntegrations.length > 0 ? (
            cloudIntegrations?.map((integration: { integrationId: string }) => (
              <IntegrationCard
                disableSelection={isReadonly}
                showSuggestion={!isReadonly}
                id={integration.integrationId}
                key={integration.integrationId}
              />
            ))
          ) : (
            <AddCloudIntegration />
          )}
        </Panel.Body>
      </Panel>
    </div>
  );
};

type BreadcrumbIcon = React.ComponentType<{
  className: string;
}>;
